import React, { useState } from 'react';

import { parseImageUrl } from '../../../../../../utils/helpers';
import { Container, Image, Title, ImagePlaceholder } from './StyledCustomer';
import fallback from '../../../../../../public/assets/placeholders/placeholder-2.svg';

type Props = {
  title?: string;
} & React.ImgHTMLAttributes<HTMLImageElement>;

export const Customer = ({ title, ...props }: Props) => {
  const { src } = props;
  const [isError, setError] = useState(false);

  return (
    <Container>
      {src && src !== 'null' && !isError ? (
        <Image src={parseImageUrl(src).src} onError={() => setError(true)} alt="preview card" />
      ) : (
        <ImagePlaceholder src={parseImageUrl(fallback).src} alt="art abstraction" />
      )}
      <Title>{title}</Title>
    </Container>
  );
};
